"use client"

import { useState } from "react"

export function SoftwareDev() {
  const [lightboxIndex, setLightboxIndex] = useState(null)

  const softwareProducts = [
    {
      src: "/placeholder.svg?height=300&width=400",
      alt: "Project Management Tool",
      title: "Project Management Tool",
      description:
        "A comprehensive project management solution that helps teams collaborate, track progress, and meet deadlines efficiently.",
      features: [
        "Task Management & Assignment",
        "Real-time Progress Tracking",
        "Team Collaboration Tools",
        "File Sharing & Storage",
        "Automated Reporting",
        "Mobile App Integration",
      ],
      technologies: ["React", "Node.js", "MongoDB", "WebSocket"],
      price: "Starting from $2,999",
    },
    {
      src: "/placeholder.svg?height=300&width=400",
      alt: "E-commerce Platform",
      title: "E-commerce Platform",
      description:
        "A scalable e-commerce solution with advanced features to help businesses sell products online effectively.",
      features: [
        "Product Management",
        "Secure Payment Integration",
        "Inventory Tracking",
        "Customer Management",
        "Analytics Dashboard",
        "Marketing Tools",
      ],
      technologies: ["Next.js", "Stripe", "PostgreSQL", "Redis"],
      price: "Starting from $3,999",
    },
    {
      src: "/placeholder.svg?height=300&width=400",
      alt: "CRM System",
      title: "CRM System",
      description:
        "A customizable customer relationship management system to streamline your sales and customer service processes.",
      features: [
        "Contact Management",
        "Sales Pipeline Tracking",
        "Email Integration",
        "Task Automation",
        "Reporting & Analytics",
        "Mobile Access",
      ],
      technologies: ["Vue.js", "Laravel", "MySQL", "Elasticsearch"],
      price: "Starting from $4,999",
    },
    {
      src: "/placeholder.svg?height=300&width=400",
      alt: "Mobile App",
      title: "Mobile App Development",
      description:
        "Custom mobile applications for iOS and Android platforms with seamless user experience and powerful features.",
      features: [
        "Cross-platform Development",
        "Native Performance",
        "Offline Functionality",
        "Push Notifications",
        "Analytics Integration",
        "Social Media Integration",
      ],
      technologies: ["React Native", "Firebase", "Swift", "Kotlin"],
      price: "Starting from $5,999",
    },
    {
      src: "/placeholder.svg?height=300&width=400",
      alt: "Data Analytics Dashboard",
      title: "Data Analytics Dashboard",
      description:
        "Interactive data visualization and analytics platform to help businesses make data-driven decisions.",
      features: [
        "Real-time Data Processing",
        "Custom Visualizations",
        "Predictive Analytics",
        "Data Export Options",
        "Role-based Access",
        "Automated Reports",
      ],
      technologies: ["Python", "TensorFlow", "D3.js", "AWS"],
      price: "Starting from $6,999",
    },
    {
      src: "/placeholder.svg?height=300&width=400",
      alt: "AI-powered Chatbot",
      title: "AI-powered Chatbot",
      description: "Intelligent chatbot solutions to automate customer support and enhance user engagement.",
      features: [
        "Natural Language Processing",
        "Multi-language Support",
        "Integration APIs",
        "Analytics Dashboard",
        "Customizable Responses",
        "24/7 Availability",
      ],
      technologies: ["Python", "TensorFlow", "NLP", "Docker"],
      price: "Starting from $3,999",
    },
  ]

  const developmentProcess = [
    {
      step: 1,
      title: "Discovery & Planning",
      description:
        "We begin with a thorough consultation to understand your business needs, objectives, and requirements.",
      activities: [
        "Initial Consultation",
        "Requirements Gathering",
        "Market Research",
        "Technology Stack Selection",
        "Project Timeline Planning",
        "Cost Estimation",
      ],
      duration: "1-2 weeks",
    },
    {
      step: 2,
      title: "Design & Prototyping",
      description: "Creating detailed designs and interactive prototypes to visualize the final product.",
      activities: [
        "UI/UX Design",
        "Wireframing",
        "Interactive Prototyping",
        "Design Review",
        "User Flow Mapping",
        "Architecture Planning",
      ],
      duration: "2-3 weeks",
    },
    {
      step: 3,
      title: "Development",
      description: "Our expert team begins the development process using agile methodologies.",
      activities: [
        "Sprint Planning",
        "Iterative Development",
        "Regular Updates",
        "Code Reviews",
        "Quality Assurance",
        "Progress Tracking",
      ],
      duration: "8-12 weeks",
    },
    {
      step: 4,
      title: "Testing & QA",
      description: "Rigorous testing to ensure quality and reliability of your software.",
      activities: [
        "Functional Testing",
        "Performance Testing",
        "Security Testing",
        "User Acceptance Testing",
        "Bug Fixing",
        "Optimization",
      ],
      duration: "2-3 weeks",
    },
    {
      step: 5,
      title: "Deployment",
      description: "Launching your software with proper setup and configuration.",
      activities: [
        "Environment Setup",
        "Data Migration",
        "Performance Monitoring",
        "Security Implementation",
        "Documentation",
        "User Training",
      ],
      duration: "1-2 weeks",
    },
    {
      step: 6,
      title: "Support & Maintenance",
      description: "Ongoing support and maintenance to ensure optimal performance.",
      activities: [
        "24/7 Technical Support",
        "Regular Updates",
        "Performance Monitoring",
        "Security Patches",
        "Feature Enhancements",
        "Backup Management",
      ],
      duration: "Ongoing",
    },
  ]

  const benefits = [
    {
      title: "Custom Solutions",
      description: "Tailored software to meet your specific business needs",
    },
    {
      title: "Cutting-edge Technology",
      description: "Utilizing the latest frameworks and tools for optimal performance",
    },
    {
      title: "Scalable Architecture",
      description: "Build for growth with scalable and flexible solutions",
    },
    {
      title: "Agile Development",
      description: "Iterative approach for faster delivery and adaptability",
    },
    {
      title: "Robust Security",
      description: "Implementing best practices for data protection and privacy",
    },
    {
      title: "Ongoing Support",
      description: "Continuous maintenance and updates post-launch",
    },
  ]

  const packages = [
    {
      name: "Standard Package",
      price: 4999,
      description: "Perfect for small to medium-sized projects",
      features: [
        "Requirements Analysis",
        "Custom Software Development",
        "User Interface Design",
        "Basic Testing",
        "Deployment Assistance",
        "30 Days Post-launch Support",
        "Source Code Ownership",
      ],
    },
    {
      name: "Enterprise Package",
      price: 9999,
      description: "Ideal for large-scale enterprise solutions",
      features: [
        "Comprehensive Requirements Analysis",
        "Advanced Custom Software Development",
        "UI/UX Design",
        "Extensive Testing & QA",
        "Deployment & Integration",
        "6 Months Post-launch Support",
        "Source Code Ownership",
        "Performance Optimization",
        "Scalability Planning",
        "Priority Support",
      ],
    },
  ]

  return (
    <section className="py-24 pt-28 bg-gradient-to-b from-gray-50 to-white overflow-hidden ">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Hero Section */}
        <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center mb-24">
          <div className="mb-12 lg:mb-0 space-y-8">
            <div className="space-y-6">
              <h1 className="text-4xl font-bold tracking-tight sm:text-5xl xl:text-6xl/none">
                Custom Software
                <span className="block mt-2">
                  Development <span className="text-red-600">Solutions</span>
                </span>
              </h1>
              <p className="text-lg text-gray-600 md:text-xl">
                Transform your business with our cutting-edge software solutions. We create custom applications tailored
                to your unique needs.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <button className="px-6 py-3 bg-red-600 hover:bg-red-700 text-white rounded-lg font-medium flex items-center transition-colors">
                  Get Started
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 ml-2"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
                <button className="px-6 py-3 border border-gray-300 hover:border-gray-400 rounded-lg font-medium flex items-center transition-colors">
                  View Portfolio
                </button>
              </div>
            </div>
            <div className="grid sm:grid-cols-2 gap-4">
              {benefits.map((benefit, index) => (
                <div
                  key={index}
                  className="p-4 bg-white rounded-lg border border-gray-200 hover:shadow-lg transition-shadow duration-200"
                >
                  <div className="flex items-start space-x-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 text-red-500 flex-shrink-0 mt-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    <div>
                      <h3 className="font-medium text-gray-900">{benefit.title}</h3>
                      <p className="text-sm text-gray-500 mt-1">{benefit.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="relative">
            <div className="relative rounded-2xl shadow-2xl overflow-hidden bg-gray-900 aspect-video group">
              <div className="absolute inset-0 bg-gradient-to-br from-gray-900/40 to-black/60 z-10" />
              <iframe
                className="absolute inset-0 w-full h-full"
                src="https://www.youtube.com/embed/dQw4w9WgXcQ"
                title="Software Development Process"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
              <div className="absolute inset-0 z-20 flex items-center justify-center">
                <div className="rounded-full bg-red-600 p-4 transform transition-transform duration-200 group-hover:scale-110">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-8 w-8 text-white"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Software Showcase with Enhanced Details */}
        <div className="mb-24">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">Our Software Portfolio</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Explore our range of custom software solutions designed to help businesses grow and succeed.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {softwareProducts.map((software, index) => (
              <div
                key={index}
                className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300"
              >
                <img
                  src={software.src || "/placeholder.svg"}
                  alt={software.alt}
                  className="w-full h-48 object-cover cursor-pointer"
                  onClick={() => setLightboxIndex(index)}
                />
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-2">{software.title}</h3>
                  <p className="text-gray-600 mb-4">{software.description}</p>
                  <div className="mb-4">
                    <h4 className="font-semibold mb-2">Key Features:</h4>
                    <ul className="list-disc list-inside text-gray-600 space-y-1">
                      {software.features.map((feature, i) => (
                        <li key={i}>{feature}</li>
                      ))}
                    </ul>
                  </div>
                  <div className="mb-4">
                    <h4 className="font-semibold mb-2">Technologies:</h4>
                    <div className="flex flex-wrap gap-2">
                      {software.technologies.map((tech, i) => (
                        <span key={i} className="px-3 py-1 bg-gray-100 rounded-full text-sm text-gray-700">
                          {tech}
                        </span>
                      ))}
                    </div>
                  </div>
                  <div className="mt-4 flex justify-between items-center">
                    <span className="text-gray-900 font-semibold">{software.price}</span>
                    <button className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors">
                      Learn More
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Development Process Section */}
        <div className="mb-24">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">Our Development Process</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              A transparent and efficient process to turn your ideas into reality.
            </p>
          </div>
          <div className="grid gap-8">
            {developmentProcess.map((phase, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg p-6 relative">
                <div className="flex flex-col md:flex-row gap-6">
                  <div className="flex-shrink-0 flex items-center justify-center w-12 h-12 rounded-full bg-red-100 text-red-600 text-xl font-bold">
                    {phase.step}
                  </div>
                  <div className="flex-grow">
                    <h3 className="text-xl font-bold mb-2">{phase.title}</h3>
                    <p className="text-gray-600 mb-4">{phase.description}</p>
                    <div className="grid md:grid-cols-2 gap-4">
                      <div>
                        <h4 className="font-semibold mb-2">Activities:</h4>
                        <ul className="list-disc list-inside text-gray-600 space-y-1">
                          {phase.activities.map((activity, i) => (
                            <li key={i}>{activity}</li>
                          ))}
                        </ul>
                      </div>
                      <div>
                        <h4 className="font-semibold mb-2">Estimated Duration:</h4>
                        <p className="text-gray-600">{phase.duration}</p>
                      </div>
                    </div>
                  </div>
                </div>
                {index < developmentProcess.length - 1 && (
                  <div className="hidden md:block absolute left-6 bottom-0 w-0.5 h-8 bg-red-200 transform translate-y-full"></div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Pricing Section */}
        <div>
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">Software Development Packages</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Choose the package that best suits your project needs. All packages include high-quality development and
              professional service.
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            {packages.map((pkg, index) => (
              <div
                key={index}
                className={`bg-white rounded-2xl shadow-lg overflow-hidden ${index === 1 ? "border-2 border-red-500" : ""}`}
              >
                {index === 1 && (
                  <div className="bg-red-500 text-white text-center py-2 text-sm font-medium">MOST POPULAR</div>
                )}
                <div className="p-8">
                  <h3 className="text-2xl font-bold mb-2">{pkg.name}</h3>
                  <p className="text-gray-600 mb-4">{pkg.description}</p>
                  <div className="flex items-baseline mb-8">
                    <span className="text-4xl font-bold">${pkg.price}</span>
                    <span className="text-gray-500 ml-2">USD</span>
                  </div>
                  <ul className="space-y-4 mb-8">
                    {pkg.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="flex items-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5 text-green-500 mr-2"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                            clipRule="evenodd"
                          />
                        </svg>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                  <button
                    className={`w-full inline-flex items-center justify-center px-6 py-3 rounded-full text-white ${
                      index === 1 ? "bg-red-500 hover:bg-red-600" : "bg-gray-800 hover:bg-gray-900"
                    } transition-colors duration-300`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 mr-2"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z"
                        clipRule="evenodd"
                      />
                    </svg>
                    Get Started
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Enhanced Lightbox */}
      {lightboxIndex !== null && (
        <div
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
          onClick={() => setLightboxIndex(null)}
        >
          <div
            className="bg-white rounded-xl max-w-4xl max-h-[90vh] overflow-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="p-6">
              <div className="flex justify-between items-start mb-4">
                <h3 className="text-2xl font-bold">{softwareProducts[lightboxIndex].title}</h3>
                <button className="p-2 hover:bg-gray-100 rounded-full" onClick={() => setLightboxIndex(null)}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              <img
                src={softwareProducts[lightboxIndex].src || "/placeholder.svg"}
                alt={softwareProducts[lightboxIndex].alt}
                className="w-full h-auto rounded-lg mb-6"
              />
              <div className="space-y-6">
                <div>
                  <h4 className="text-lg font-semibold mb-2">Description</h4>
                  <p className="text-gray-600">{softwareProducts[lightboxIndex].description}</p>
                </div>
                <div>
                  <h4 className="text-lg font-semibold mb-2">Key Features</h4>
                  <ul className="grid grid-cols-2 gap-2">
                    {softwareProducts[lightboxIndex].features.map((feature, i) => (
                      <li key={i} className="flex items-center text-gray-600">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5 text-green-500 mr-2"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                            clipRule="evenodd"
                          />
                        </svg>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
                <div>
                  <h4 className="text-lg font-semibold mb-2">Technologies Used</h4>
                  <div className="flex flex-wrap gap-2">
                    {softwareProducts[lightboxIndex].technologies.map((tech, i) => (
                      <span key={i} className="px-3 py-1 bg-gray-100 rounded-full text-sm text-gray-700">
                        {tech}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="flex justify-between items-center pt-4 border-t">
                  <span className="text-xl font-bold text-gray-900">{softwareProducts[lightboxIndex].price}</span>
                  <button className="px-6 py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors">
                    Get Started
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  )
}

